import { RouteError } from '@/components/route-error'
import { createFileRoute } from '@tanstack/react-router'
import { RoutePending } from '@/components/route-pending'
import { PricingPage } from './_dashboard.catalog.pricing'

export const Route = createFileRoute('/_dashboard/catalog/pricing/')({
  pendingComponent: RoutePending,
  errorComponent: RouteError,
  component: PricingIndexPage,
})

function PricingIndexPage() {
  return <PricingPage selectedId={undefined} />
}
